module.exports = __webpack_public_path__ + "static/img/special.d904f17e.png";